.banner {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 4px 0;
  padding: 8px 12px;
  width: var(--table-w);
  border-radius: var(--radius-chip);
  font-size: 12px;
  line-height: 16px;
}
.fixture { background: #fff8e1; color: #6b5200; box-shadow: inset 0 0 0 1px #f2e2ad; }
.error   { background: #fdecec; color: #8a1f1f; box-shadow: inset 0 0 0 1px #f3c9c9; }
.dot { width: 6px; height: 6px; border-radius: 50%; background: currentColor; flex-shrink: 0; }
.detail { color: inherit; opacity: 0.75; }
